import React from 'react';

interface ITrafficLightValue {
  value: -1 | 0 | 1;
}

interface IDotColor {
  color: string;
}

const Dot: React.FC<IDotColor> = ({ color }) => (
  <div className={`ml1 br-100 bg-${color}`} style={{ width: 14, height: 14 }} />
);

const TrafficLightMiniViz: React.FC<ITrafficLightValue> = ({ value }) => {
  let color: string;
  if (value === -1) {
    color = 'red';
  } else if (value === 0) {
    color = 'yellow';
  } else {
    color = 'green';
  }

  return <Dot color={color} />;
};

export default TrafficLightMiniViz;
